import { toastAPI } from 'app/config/toast.config';
import { getError, getSuccess } from 'app/services/toast.service';
import { useTranslation } from 'react-i18next';

function useToast(model, type) {
  const { t } = useTranslation(['common']);

  const dismissTimeout = 8000;

  const errorGeneral = t('toast:error_general');
  const successGeneral = t('toast:success_general');

  function openToast({ error, message, state = 'success', timeout, isList = false }) {
    const appearance = error ? 'error' : state;
    const textDefault = error ? errorGeneral : successGeneral;
    const text = message || textDefault;
    const duration = timeout || dismissTimeout;

    toastAPI.show(text, { appearance, duration, isList });
  }

  function openToastResponse({ response, message, state, timeout, isList = false }) {
    const { error } = response;
    const appearance = error ? 'error' : state || 'success';
    const textDefault = error ? errorGeneral : successGeneral;
    const text = getText({ error, message });
    const duration = timeout || dismissTimeout;

    toastAPI.show(text || textDefault, { appearance, duration, isList });
  }

  function getText({ error, message }) {
    const textMessage = message || getTextSuccess();
    return error ? getTextError({ error }) : textMessage;
  }

  function getTextSuccess() {
    return getSuccess(model, type);
  }

  function getTextError({ error }) {
    const { data } = error;
    return getError(data, model);
  }

  return {
    openToast,
    openToastResponse,
  };
}

export default useToast;
